var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var bookingformParams = [
    "ftimespans",
    "fcourses",
    "fplaces",
    "ftags",
    "ftimespansnot",
    "fcoursesnot",
    "fplacesnot",
    "ftagsnot",
    "fnextdays",
    "cn",
    "campaign",
    "campaign_name",
    "perpage",
];
export var courseTableParams = __spreadArray(__spreadArray([], bookingformParams), [
    "page",
    "disableinfo",
    "columns",
    "fixedColumns",
    "filters",
    "showSearchFilter",
    "disablefilter_months",
    "disablefilter_places",
    "disablefilter_courses",
]);
export var userAccountParams = __spreadArray(__spreadArray([], bookingformParams), [
    "authEntities",
    "userBillsColumns",
    "userBookingsColumns",
    "userPaymentsColumns",
    "authMode"
]);
